'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'face-vomit';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e3a0';
var svgPathData = 'M288 32c-123.7 0-224 100.3-224 224 0 57.4 21.6 109.7 57 149.3l-10.6 9.5-15.6 9.1C55.7 379 32 320.2 32 256 32 114.6 146.6 0 288 0S544 114.6 544 256c0 64.2-23.7 123-62.8 167.9l-15.6-9.1-10.6-9.5c35.5-39.6 57-91.9 57-149.3 0-123.7-100.3-224-224-224zM146.2 175.2l14.3-28.6 14.3 7.2 80 40 9.2 4.6 0 19.4-9.2 4.6-80 40-14.3 7.2-14.3-28.6c3.4-1.7 25.3-12.6 65.7-32.8-40.4-20.2-62.3-31.2-65.7-32.8zm269.4 7.2L364.2 208c40.4 20.2 62.3 31.2 65.7 32.8l-14.3 28.6-14.3-7.2-80-40-9.2-4.6 0-19.4 9.2-4.6 80-40 14.3-7.2 14.3 28.6-14.3 7.2zM40 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm472-8a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 327.7l0 49.2c0 39.8-21.2 76.7-55.6 96.7l-11 6.4 261.1 0-11-6.4c-34.4-20.1-55.6-56.9-55.6-96.7l0-49.2c-18.2-4.4-39.8-7.7-64-7.7s-45.8 3.2-64 7.7zm-32 10.2c-10.8 4.3-18.7 8.5-23.1 11.5l-17.8-26.6C169.7 310.3 220.8 288 288 288s118.3 22.3 136.9 34.7l-17.8 26.6c-4.4-3-12.3-7.2-23.1-11.5l0 39c0 28.5 15.1 54.8 39.7 69.1l48.4 28.2 7.9 4.6 0 33.2-384 0 0-33.2 7.9-4.6 48.4-28.2c24.6-14.3 39.7-40.6 39.7-69.1l0-39zM304 384a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceVomit = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;